// INTL-489 — footer link + modal gating (BM pref EU_LEGAL_GUARANTEE_COUNTRY_CODES)

export const DEFAULT_EU_LEGAL_GUARANTEE_COUNTRY_CODES = [
    'AT',
    'BE',
    'DE',
    'ES',
    'FR',
    'IE',
    'IT',
    'NL'
]

const DISABLED_VALUES = new Set(['off', 'disable', 'disabled', 'false', 'none'])

// Official notice SVG is per language, not per country (see Commission asset pack).
export const LOCALE_ID_TO_NOTICE_LANG = {
    'de-AT': 'de',
    'de-DE': 'de',
    'fr-FR': 'fr',
    'en-IE': 'en',
    'it-IT': 'it',
    'nl-NL': 'nl',
    'nl-BE': 'nl',
    'es-ES': 'es'
}

export const parseEuLegalGuaranteeCountryCodes = (rawPref) => {
    const trimmed = String(rawPref ?? '').trim()

    if (!trimmed) {
        return {
            enabled: true,
            countryCodes: new Set(DEFAULT_EU_LEGAL_GUARANTEE_COUNTRY_CODES)
        }
    }

    if (DISABLED_VALUES.has(trimmed.toLowerCase())) {
        return {enabled: false, countryCodes: new Set()}
    }

    const countryCodes = trimmed
        .split(',')
        .map((code) => code.trim().toUpperCase())
        .filter(Boolean)

    return {
        enabled: countryCodes.length > 0,
        countryCodes: new Set(countryCodes)
    }
}

export const isEuLegalGuaranteeCountry = (countryCode, rawPref) => {
    const {enabled, countryCodes} = parseEuLegalGuaranteeCountryCodes(rawPref)

    if (!enabled) {
        return false
    }

    const normalizedCountry = String(countryCode ?? '').trim().toUpperCase()
    return Boolean(normalizedCountry && countryCodes.has(normalizedCountry))
}

export const getEuLegalGuaranteeNoticeLang = (localeId) => {
    const lang = LOCALE_ID_TO_NOTICE_LANG[String(localeId ?? '')]
    return lang || null
}

export const getEuLegalGuaranteeNoticeAssetPath = (localeId) => {
    const lang = getEuLegalGuaranteeNoticeLang(localeId)
    if (!lang) {
        return null
    }

    return `static/img/eu-legal-guarantee/${lang}.svg`
}

// Prepends the synthetic Legals link; skips if CMS already has one.
export const appendEuLegalGuaranteeLinkToFooterSections = (sections, {legalsTitle, link}) => {
    if (!link || !Array.isArray(sections)) {
        return sections
    }

    const legalsTitleLower = String(legalsTitle || '').toLowerCase().trim()

    return sections.map((section) => {
        const sectionTitleLower = String(section.title || '').toLowerCase().trim()
        const isLegalsSection =
            section.sectionId === 'legals' ||
            sectionTitleLower === legalsTitleLower ||
            sectionTitleLower === 'legals'

        if (!isLegalsSection) {
            return section
        }

        if (section.links?.some((footerLink) => footerLink.isEuLegalGuarantee)) {
            return section
        }

        return {
            ...section,
            links: [link, ...(section.links || [])]
        }
    })
}
